import HeaderSortAscChevron from 'assets/svg/HeaderSortAscChevron';
import HeaderSortDescChevron from 'assets/svg/HeaderSortDescChevron';
import type { ScenarioManagerColumn } from '../types';

type ProjectSort = {
    id: string;
    direction: 'asc' | 'desc';
};

type SortableHeaderProps = {
    column: ScenarioManagerColumn;
    projectSort?: ProjectSort;
    onSort: (columnId: string, direction: 'asc' | 'desc') => void;
};

const SortableHeader = ({ column, projectSort, onSort }: SortableHeaderProps) => {
    const currentColumnId = column.id;
    const isSortableProjectColumn = Boolean(currentColumnId && column.is_sort);
    const sortActive =
        isSortableProjectColumn && projectSort?.id === currentColumnId ? projectSort?.direction : null;

    return (
        <div className="flex items-center gap-2">
            <span className="w-full inline-flex items-center justify-between gap-1.5">
                <span>{column.label || column.id || '-'}</span>
                {isSortableProjectColumn && currentColumnId ? (
                    <span className="inline-flex shrink-0 flex-col items-center justify-center gap-0.5">
                        <button
                            type="button"
                            className={`inline-flex h-[5px] items-center justify-center transition-colors ${
                                sortActive === 'asc' ? 'text-[#44338a]' : 'text-black/30 hover:text-black/55'
                            }`}
                            onClick={(event) => {
                                event.stopPropagation();
                                onSort(currentColumnId, 'asc');
                            }}
                            aria-label={`Sort ${column.label || column.id || 'column'} ascending`}
                        >
                            <HeaderSortAscChevron />
                        </button>
                        <button
                            type="button"
                            className={`inline-flex h-[5px] items-center justify-center transition-colors ${
                                sortActive === 'desc' ? 'text-[#44338a]' : 'text-black/30 hover:text-black/55'
                            }`}
                            onClick={(event) => {
                                event.stopPropagation();
                                onSort(currentColumnId, 'desc');
                            }}
                            aria-label={`Sort ${column.label || column.id || 'column'} descending`}
                        >
                            <HeaderSortDescChevron />
                        </button>
                    </span>
                ) : null}
            </span>
        </div>
    );
};

export default SortableHeader;
